import { cva, type VariantProps } from 'class-variance-authority';

const buttonStyles = cva('px-4 py-2 rounded', {
  variants: {
    variant: {
      default: 'bg-blue-500 text-white hover:bg-blue-600',
      outline: 'border border-blue-500 text-blue-500 hover:bg-blue-50',
    },
    size: {
      sm: 'text-sm',
      lg: 'text-lg px-6 py-3',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'lg',
  },
});

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, 
  VariantProps<typeof buttonStyles> {}

export function Button({ variant, size, className, children, ...props }: ButtonProps) {
  return (
    <button 
      className={buttonStyles({ variant, size, className })} 
      {...props}
    >
      {children}
    </button>
  );
}
